<template>
  <footer class="py-5 footer">
    <div class="container">
      <div class="row" style="padding-top: 100px;">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary">
            Copyright © {{ new Date().getFullYear() }} The Perfect World
            Foundation
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
